function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1200px",
    height: "532px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#009f98",
    d: "M -0.5,-0.5 C 399.5,-0.5 799.5,-0.5 1199.5,-0.5C 1199.5,176.833 1199.5,354.167 1199.5,531.5C 799.5,531.5 399.5,531.5 -0.5,531.5C -0.5,354.167 -0.5,176.833 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#84d0cd",
    d: "M 1155.5,46.5 C 785.5,46.5 415.5,46.5 45.5,46.5C 45.5,193.167 45.5,339.833 45.5,486.5C 44.5004,339.668 44.167,192.668 44.5,45.5C 415,45.1668 785.334,45.5002 1155.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 1155.5,46.5 C 1155.5,193.167 1155.5,339.833 1155.5,486.5C 785.5,486.5 415.5,486.5 45.5,486.5C 45.5,339.833 45.5,193.167 45.5,46.5C 415.5,46.5 785.5,46.5 1155.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#049f98",
    d: "M 826.5,199.5 C 826.5,206.833 826.5,214.167 826.5,221.5C 806.5,221.5 786.5,221.5 766.5,221.5C 767.056,192.561 753.056,180.728 724.5,186C 707.621,194.99 703.454,208.157 712,225.5C 714.921,229.092 718.421,231.925 722.5,234C 740.85,238.537 759.183,243.204 777.5,248C 826.953,262.058 844.12,293.892 829,343.5C 818.8,366.034 801.967,381.2 778.5,389C 747.283,398.181 716.283,397.514 685.5,387C 652.958,372.114 638.292,346.614 641.5,310.5C 662.66,309.503 683.993,309.169 705.5,309.5C 705.182,314.032 705.515,318.366 706.5,322.5C 707.592,333.76 713.592,340.926 724.5,344C 734.837,346.433 744.837,345.433 754.5,341C 763.584,333.191 766.751,323.357 764,311.5C 759.728,301.566 752.228,295.732 741.5,294C 721.739,291.301 702.739,285.968 684.5,278C 652.62,261.068 639.787,234.568 646,198.5C 654.701,168.798 673.868,149.298 703.5,140C 734.844,131.526 764.844,134.86 793.5,150C 811.874,161.548 822.874,178.048 826.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#029f98",
    d: "M 576.5,390.5 C 555.5,390.5 534.5,390.5 513.5,390.5C 513.831,361.995 513.498,333.662 512.5,305.5C 491.833,305.5 471.167,305.5 450.5,305.5C 450.5,333.833 450.5,362.167 450.5,390.5C 429.167,390.5 407.833,390.5 386.5,390.5C 386.333,335.832 386.5,281.166 387,226.5C 392.32,170.511 422.987,141.177 479,138.5C 504.719,137.629 527.552,145.129 547.5,161C 564.105,177.714 573.605,197.881 576,221.5C 576.5,277.832 576.667,334.166 576.5,390.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#27aca6",
    d: "M 897.5,142.5 C 950.997,141.501 1004.66,141.168 1058.5,141.5C 1058.83,158.342 1058.5,175.008 1057.5,191.5C 1057.5,175.167 1057.5,158.833 1057.5,142.5C 1004.17,142.5 950.833,142.5 897.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#049f98",
    d: "M 141.5,141.5 C 179.168,141.333 216.835,141.5 254.5,142C 284.721,144.349 306.221,159.182 319,186.5C 326.583,207.11 323.583,226.11 310,243.5C 305.943,249.278 300.777,253.778 294.5,257C 325.973,271.783 337.806,296.283 330,330.5C 322.891,356.279 306.724,373.779 281.5,383C 271.735,386.186 261.735,388.02 251.5,388.5C 214.833,388.5 178.167,388.5 141.5,388.5C 141.5,306.167 141.5,223.833 141.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#009f97",
    d: "M 897.5,142.5 C 950.833,142.5 1004.17,142.5 1057.5,142.5C 1057.5,158.833 1057.5,175.167 1057.5,191.5C 1024.83,191.5 992.167,191.5 959.5,191.5C 959.5,207.167 959.5,222.833 959.5,238.5C 990.996,239.498 1022.66,239.832 1054.5,239.5C 1054.5,254.5 1054.5,269.5 1054.5,284.5C 1022.83,284.5 991.167,284.5 959.5,284.5C 959.5,303.167 959.5,321.833 959.5,340.5C 991.996,341.498 1024.66,341.832 1057.5,341.5C 1057.5,357.833 1057.5,374.167 1057.5,390.5C 1004.17,390.5 950.833,390.5 897.5,390.5C 897.5,307.833 897.5,225.167 897.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfefe",
    d: "M 475.5,185.5 C 496.34,183.32 509.173,192.32 514,212.5C 514.5,227.496 514.667,242.496 514.5,257.5C 493.833,257.5 473.167,257.5 452.5,257.5C 452.058,240.444 452.558,223.444 454,206.5C 457.212,195.334 464.379,188.334 475.5,185.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 203.5,187.5 C 218.891,187.065 234.225,187.565 249.5,189C 264.062,198.603 267.562,211.436 260,227.5C 257.448,231.719 253.948,234.886 249.5,237C 234.238,238.452 218.905,238.952 203.5,238.5C 203.5,221.5 203.5,204.5 203.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#51bcb7",
    d: "M 826.5,199.5 C 827.492,206.982 827.825,214.648 827.5,222.5C 806.993,222.83 786.66,222.497 766.5,221.5C 786.5,221.5 806.5,221.5 826.5,221.5C 826.5,214.167 826.5,206.833 826.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5fc2be",
    d: "M 959.5,238.5 C 991.5,238.5 1023.5,238.5 1055.5,238.5C 1055.83,254.009 1055.5,269.342 1054.5,284.5C 1054.5,269.5 1054.5,254.5 1054.5,239.5C 1022.66,239.832 990.996,239.498 959.5,238.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 203.5,283.5 C 218.837,283.333 234.17,283.5 249.5,284C 270.04,290.914 276.873,304.747 270,325.5C 264.89,336.929 256.057,343.429 243.5,345C 230.171,345.5 216.837,345.667 203.5,345.5C 203.5,324.833 203.5,304.167 203.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1edec",
    d: "M 512.5,305.5 C 512.5,305.833 512.5,306.167 512.5,306.5C 492.167,306.5 471.833,306.5 451.5,306.5C 451.831,334.672 451.498,362.672 450.5,390.5C 450.5,362.167 450.5,333.833 450.5,305.5C 471.167,305.5 491.833,305.5 512.5,305.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#65c4bf",
    d: "M 706.5,322.5 C 705.515,318.366 705.182,314.032 705.5,309.5C 683.993,309.169 662.66,309.503 641.5,310.5C 640.957,310.44 640.624,310.107 640.5,309.5C 662.49,308.5 684.49,308.167 706.5,308.5C 706.5,313.167 706.5,317.833 706.5,322.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#62c2bd",
    d: "M 959.5,340.5 C 992.5,340.5 1025.5,340.5 1058.5,340.5C 1058.5,357.5 1058.5,374.5 1058.5,391.5C 1004.66,391.832 950.997,391.499 897.5,390.5C 950.833,390.5 1004.17,390.5 1057.5,390.5C 1057.5,374.167 1057.5,357.833 1057.5,341.5C 1024.66,341.832 991.996,341.498 959.5,340.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#34b2ac",
    d: "M 141.5,141.5 C 141.5,223.833 141.5,306.167 141.5,388.5C 178.167,388.5 214.833,388.5 251.5,388.5C 214.67,389.498 177.67,389.832 140.5,389.5C 140.167,306.665 140.501,223.998 141.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#89d2cf",
    d: "M 512.5,305.5 C 513.498,333.662 513.831,361.995 513.5,390.5C 534.5,390.5 555.5,390.5 576.5,390.5C 555.34,391.497 534.007,391.831 512.5,391.5C 512.5,363.167 512.5,334.833 512.5,306.5C 512.5,306.167 512.5,305.833 512.5,305.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseLogo);
export default __webpack_public_path__ + "static/media/base_logo.6c7238663a1cb7ff17a6ebf158db22e1.svg";
export { ForwardRef as ReactComponent };